import Vue from 'Vue';
import App from './App.vue';
import i18n from '../i18n';

/**
 * importing the global style. This will hold some of the common styles. Component specific styles belong to the component!
 */
import './assets/css/main.scss';
import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faSpinner,
    faMapMarkerAlt,
    faCalendarAlt,
    faTimesCircle,
    faAngleUp,
    faSearch,
    faSuitcaseRolling,
    faAtlas,
    faCloudSunRain,
    faUmbrellaBeach,
    faTree,
    faFlag,
    faSkiing
} from '@fortawesome/free-solid-svg-icons';
import 'document-register-element/build/document-register-element';
import vueCustomElement from 'vue-custom-element';
import store from '../vuex.store';
import InfiniteLoading from 'vue-infinite-loading';

// configuring font awesome
config.autoAddCss = false;
library.add(
    faSpinner,
    faMapMarkerAlt,
    faCalendarAlt,
    faTimesCircle,
    faAngleUp,
    faSearch,
    faSuitcaseRolling,
    faAtlas,
    faCloudSunRain,
    faUmbrellaBeach,
    faTree,
    faFlag,
    faSkiing
);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(vueCustomElement);
Vue.config.productionTip = false;

Vue.use(InfiniteLoading);

// use vue-custom-element
App.i18n = i18n;
App.store = store;
Vue.customElement('datacycle-map-widget', App);
